import { Route, Routes } from 'react-router-dom'
import { RequireAuth } from '@/components/RequireAuth'
import { RequireSurface } from '@/components/RequireSurface'
import { RequireUnauth } from '@/components/RequireUnauth'
import { AccountPassword } from '@/routes/AccountPassword'
import { Audit } from '@/routes/Audit'
import { BillingReports } from '@/routes/BillingReports'
import { BillingSettings } from '@/routes/BillingSettings'
import { HelpRequests } from '@/routes/HelpRequests'
import { Home } from '@/routes/Home'
import { Login } from '@/routes/Login'
import { Maintenance } from '@/routes/Maintenance'
import { NotFound } from '@/routes/NotFound'
import { ModerationActions } from '@/routes/ModerationActions'
import { RateLimits } from '@/routes/RateLimits'
import { UserDetailRoute } from '@/routes/UserDetailRoute'
import { Users } from '@/routes/Users'

function App() {
  return (
    <Routes>
      {/* Auth-required területek (DEC-FE-006 / DEC-FE-013) */}
      <Route element={<RequireAuth />}>
        {/* Shared — any admin */}
        <Route path="/" element={<Home />} />
        <Route path="/account/password" element={<AccountPassword />} />

        {/* Moderation surface (user_admin / admin) — DEC-ADMIN-013 */}
        <Route element={<RequireSurface surface="moderation" />}>
          <Route path="/help-requests" element={<HelpRequests />} />
          <Route path="/users" element={<Users />} />
          {/* DEC-ADMIN-014 — felhasználó-részletlap */}
          <Route path="/users/:id" element={<UserDetailRoute />} />
          <Route path="/moderation-actions" element={<ModerationActions />} />
        </Route>

        {/* Operations surface (ops_admin / admin) — DEC-ADMIN-013 */}
        <Route element={<RequireSurface surface="operations" />}>
          <Route path="/rate-limits" element={<RateLimits />} />
          <Route path="/audit" element={<Audit />} />
          <Route path="/maintenance" element={<Maintenance />} />
          <Route path="/billing-reports" element={<BillingReports />} />
          <Route path="/billing-settings" element={<BillingSettings />} />
        </Route>
      </Route>

      {/* Guest-only — admin login form */}
      <Route element={<RequireUnauth />}>
        <Route path="/auth/login" element={<Login />} />
      </Route>

      <Route path="*" element={<NotFound />} />
    </Routes>
  )
}

export default App
